<template>
    <div>    
        <section class="page-section bg-light" id="listen">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 text-left">
                        <h2 class="mt-0 mb-4">
                            <img src="/img/article1/valora.png" width="50px" class="mr-2"/>
                            <b>Valora</b> Musical Scores
                        </h2>
                        <hr>
                        <p>
                            Valora is a product (created by the bay area company Celo) to transact finances, specifically Celo's cryptocurrency. 
                            I was contracted to compose several musical compositions with a single
                            underlying theme, ultimately providing a thematic musical suite that 
                            best signifies Valora's utility for communal wealth. 
                         </p>
                         <p>
                             The project took 3-4 months, weekly creative debriefs and strict deadlines for each musical composition.
                             
                          </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 text-left"  v-for="item in items" v-bind:key="item.id">
                        <div class="mt-5">
                            <h3 class="h4 mb-2">
                                <a target="_blank" v-bind:href="'https://www.youtube.com/watch?v='+ item.id">
                                    {{ item.title }}
                                </a>
                            </h3>
                        </div>
                        <div class="mt-2">
                            <a target="_blank" v-bind:href="'https://www.youtube.com/watch?v='+ item.id">
                                <img v-bind:src="'http://img.youtube.com/vi/'+ item.id + '/0.jpg'" async class="rounded w-90 shadow play-youtube-video lazy ">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        

    </div>
</template>

<script>
export default {
    name: 'Article1',
    components: {
    },
    data: function(){
        return{
            items: [
                { 
                    title: 'Share What You Value',  
                    id:'HW8ShT8_kOU'
                },
                { 
                    title: 'Give What You Value',  
                    id:'s90LVaP6pMc'
                },
                { 
                    title: 'Nurture What You Value',  
                    id:'D5cHuOAOan8'
                },{ 
                    title: 'Revive What You Value',  
                    id:'mN4jYmPNMtk'
                }
            ]
        }
    }
}
</script>
